import { FC, createContext, useState, useContext } from 'react';

export type EventUserContextValue = {
  setNewEventUser: any;
  eventUser: any;
};

const EventUserContext = createContext<EventUserContextValue>({
  setNewEventUser: () => null,
  eventUser: null,
});

export const EventUserProvider: FC<
  React.PropsWithChildren<unknown>
> = props => {
  const { children } = props;

  const [eventUser, setEventUser] = useState(null);

  const setNewEventUser = (user: any) => {
    return new Promise<void>(resolve => {
      setEventUser(user);
      resolve();
    });
  };

  return (
    <EventUserContext.Provider
      value={{
        setNewEventUser,
        eventUser,
      }}
    >
      {children}
    </EventUserContext.Provider>
  );
};

export const useEventUser = () => useContext(EventUserContext);

export const EventUserConsumer = EventUserContext.Consumer;

export default EventUserContext;
